import DispatchProps from "./DispatchProps";
import {MessageBarType} from "office-ui-fabric-react";
import Actions from "../redux/Actions";
import {IMessageBarHelper} from "./IMessageBarHelper";

export class MessageBarHelper implements IMessageBarHelper
{
    private dispatchProps: DispatchProps;

    constructor(dispatchProps: DispatchProps) {
        this.dispatchProps = dispatchProps;
    }

    private sendMessage(message: string,type: MessageBarType, actions: JSX.Element | undefined): void
    {
        this.dispatchProps.dispatch(Actions.showMessageBar(message,type,actions));
    }

    public info(message: string, actions: JSX.Element | undefined): void {
        this.sendMessage(message,MessageBarType.info,actions)
    }

    public success(message: string, actions: JSX.Element | undefined): void {
        this.sendMessage(message,MessageBarType.success,actions)
    }

    public warning(message: string, actions: JSX.Element | undefined): void {
        this.sendMessage(message,MessageBarType.warning,actions)
    }

    public error(message: string, actions: JSX.Element | undefined): void {
        this.sendMessage(message,MessageBarType.error,actions)
    }
}
